/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_settings_subscription_management_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 구독 플랜과 결제 정보를 관리하고 변경하세요`)
};

const en_settings_subscription_management_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage and modify your current subscription plan and payment information`)
};

const ja_settings_subscription_management_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のサブスクリプションプランと決済情報を管理・変更`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_subscription_management_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_subscription_management_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_subscription_management_description", locale)
	if (locale === "ko") return ko_settings_subscription_management_description(inputs)
	if (locale === "en") return en_settings_subscription_management_description(inputs)
	return ja_settings_subscription_management_description(inputs)
};